module.exports = __webpack_public_path__ + "static/img/aixin.7f2c8c21.png";